import { NavLink, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Building2, Settings as SettingsIcon } from "lucide-react";
import { clearSession, getEmail } from "@/lib/auth";
import { toast } from "sonner";

const links = [
  { to: "/admin", label: "Inbox", icon: LayoutDashboard, end: true },
  { to: "/admin/listings", label: "Listings", icon: Building2 },
  { to: "/admin/settings", label: "Site Settings", icon: SettingsIcon },
];

export const AdminNav = () => {
  const navigate = useNavigate();
  const logout = () => {
    clearSession();
    toast.success("Signed out.");
    navigate("/admin/login", { replace: true });
  };
  return (
    <div className="sticky top-0 z-30 bg-[#F8FAFC]/85 backdrop-blur-xl border-b border-slate-200/60">
      <div className="px-6 md:px-12 lg:px-24 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="inline-block w-8 h-8 rounded-lg bg-[#0A2540] text-white flex items-center justify-center font-heading text-sm font-medium">
            IP
          </span>
          <p className="font-heading text-sm font-medium text-slate-900 hidden sm:block">
            Owner Panel
          </p>
        </div>

        <nav className="flex items-center gap-1 bg-white border border-slate-200 rounded-full p-1 shadow-sm">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`adminnav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-3.5 sm:px-4 h-9 rounded-full text-xs sm:text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#0A2540] text-white"
                    : "text-slate-600 hover:bg-slate-50"
                }`
              }
            >
              <l.icon size={14} strokeWidth={1.5} />
              <span className="hidden sm:inline">{l.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="text-xs text-slate-500 hidden md:inline">{getEmail()}</span>
          <button
            data-testid="adminnav-logout"
            onClick={logout}
            className="inline-flex items-center gap-1.5 px-3 h-9 rounded-full bg-[#0A2540] hover:bg-[#0F172A] text-white text-xs font-medium"
          >
            <LogOut size={13} strokeWidth={1.5} />
            <span className="hidden sm:inline">Sign Out</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
